var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"headerBox",style:(_vm.indexFlag ? 'background-color: #fff;' : '')},[_c('Head',{staticClass:"header"})],1),_c('div',{staticClass:"main"},[_c('router-view',{class:_vm.indexFlag ? 'mgt70' : ''})],1),_c('div',{staticClass:"footer"},[_c('FooterItem',{staticClass:"footer_center"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }